import { TriangleAlertIcon } from 'lucide-react';

type Props = {
    className?: string;
};

export const WarningIcon = TriangleAlertIcon;
